import { roleLabel } from "@/lib/roles";

// Hledání v menu na telefonu (200): kromě modulů i zakázky a lidi, klepnutí otevře
// jejich kartu. Bez diakritiky, všechna slova dotazu musí sedět (v libovolném pořadí);
// nahoru jde shoda na začátku názvu, pak na začátku slova, pak kdekoli.

export const norm = (s) => String(s || "").toLowerCase().normalize("NFD").replace(/[̀-ͯ]/g, "");

function score(name, hay, words) {
  if (!words.length || !words.every((w) => hay.includes(w))) return -1;
  const n = norm(name);
  const q = words.join(" ");
  if (n.startsWith(q)) return 3;
  if (words.every((w) => n.split(/[\s\-–,./]+/).some((part) => part.startsWith(w)))) return 2;
  return 1;
}

function rank(list, q, hayOf, nameOf, limit) {
  const words = norm(q).split(/\s+/).filter(Boolean);
  if (!words.length) return { rows: [], total: 0 };
  const hits = [];
  (list || []).forEach((it, i) => {
    const s = score(nameOf(it), norm(hayOf(it)), words);
    if (s >= 0) hits.push({ it, s, i });
  });
  hits.sort((a, b) => b.s - a.s || String(nameOf(a.it)).localeCompare(String(nameOf(b.it)), "cs") || a.i - b.i);
  return { rows: hits.slice(0, limit).map((h) => h.it), total: hits.length };
}

// zakázky: název, číslo, adresa, investor
export function searchProjects(projects, q, limit = 5) {
  const r = rank(projects, q, (p) => `${p.name || ""} ${p.code || ""} ${p.address || ""} ${p.investor?.name || ""}`, (p) => p.name || "", limit);
  return {
    total: r.total,
    rows: r.rows.map((p) => ({ id: p.id, name: p.name || "Zakázka", sub: [p.code, p.address || p.investor?.name, p.status].filter(Boolean).join(" · "), to: `/zakazky/${p.id}` })),
  };
}

// lidé: jméno, role (česky), pozice; bez vyřazených
export function searchPeople(people, q, limit = 5) {
  const active = (people || []).filter((u) => u && u.status !== "inactive");
  const r = rank(active, q, (u) => `${u.name || ""} ${roleLabel(u.role)} ${u.position || ""}`, (u) => u.name || "", limit);
  return {
    total: r.total,
    rows: r.rows.map((u) => ({ id: u.id, name: u.name || "—", photo: u.photo_url || null, sub: u.position || roleLabel(u.role), to: `/tym/${u.id}` })),
  };
}
